import { cartStore } from "@features/auth/tess-cart.store"
import { RiTimerLine } from "@remixicon/react"
import { observer } from "mobx-react-lite"
import { useEffect, useState } from "react"

export const CartCountdownTimer = observer(() => {
  const expiration = cartStore.expirationDate

  function getTimeLeft() {
    if (!expiration) return null
    const now = new Date()
    const diff = expiration.getTime() - now.getTime()
    if (diff <= 0) {
      return "Cart expired"
    }
    const minutes = Math.floor(diff / 60000)
    const seconds = Math.floor((diff % 60000) / 1000)
    return `${minutes}:${seconds.toString().padStart(2, "0")}`
  }

  const [timeLeft, setTimeLeft] = useState(getTimeLeft())

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(getTimeLeft())
    }, 1000)
    return () => clearInterval(interval)
  }, [expiration])

  if (!expiration) return null

  return (
    <div className="border type-body-m mt-5 p-2 items-center flex gap-[0.5em]">
      <RiTimerLine className="size-[1.4em]" />
      Time Remaining: {timeLeft}
    </div>
  )
})
